import { render, staticRenderFns } from "./ViewerNavBar.vue?vue&type=template&id=6fcb44e4&scoped=true"
import script from "./ViewerNavBar.vue?vue&type=script&lang=js"
export * from "./ViewerNavBar.vue?vue&type=script&lang=js"
import style0 from "./ViewerNavBar.vue?vue&type=style&index=0&id=6fcb44e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb44e4",
  null
  
)

export default component.exports